import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const Breadcrumbs = dynamic(() => import('./Breadcrumbs').then((m) => ({ default: m.Breadcrumbs })));

const BreadcrumbsConfig = {
  name: 'Breadcrumbs',
  inputs: [
    {
      name: 'pageTitle',
      type: 'string',
    },
    { name: 'breadcrumb', type: 'reference', model: 'breadcrumb' },
  ],
};

Builder.registerComponent(Breadcrumbs, BreadcrumbsConfig);
